var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIconHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 16.6651L6.66691 35.0001M30.0002 5.00008L25.0002 10.0001C24.0919 10.9084 23.6369 11.3634 23.3936 11.8534C23.1656 12.3135 23.047 12.82 23.047 13.3334C23.047 13.8469 23.1656 14.3534 23.3936 14.8134C23.6369 15.3034 24.0919 15.7584 25.0002 16.6667C25.9086 17.5751 26.3636 18.0301 26.8536 18.2734C27.3136 18.5014 27.8201 18.62 28.3336 18.62C28.847 18.62 29.3535 18.5014 29.8136 18.2734C30.3036 18.0301 30.7586 17.5751 31.6669 16.6667L36.6669 11.6667M33.3336 8.33008L28.3336 13.3301M14.7419 16.4084C12.4669 18.6834 9.34691 19.2517 6.50191 16.4084C3.65858 13.5634 2.16858 8.38508 4.44358 6.10841C6.71858 3.83508 11.8969 5.32508 14.7419 8.16841C17.5852 11.0134 17.0169 14.1334 14.7419 16.4084ZM14.7419 16.4084L33.3336 34.9984",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconHover);
export default __webpack_public_path__ + "static/media/MenuIconHover.307bce5124a2ed7fe040e51a106c5243.svg";
export { ForwardRef as ReactComponent };